import { useState } from "react";
import Navbar from "@/components/Navbar";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { FloppyDisk, User } from "@phosphor-icons/react";
import { CustomHolidaysCard } from "@/components/CustomHolidaysCard";

export default function Settings() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ name: user?.name || "", whatsapp_number: user?.whatsapp_number || "" });
  const [saving, setSaving] = useState(false);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.patch("/auth/me", form);
      setUser(data);
      toast.success("Profil tersimpan");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Navbar />
      <main className="max-w-2xl mx-auto px-6 py-10">
        <span className="nb-badge">Pengaturan</span>
        <h1 className="font-display font-black text-4xl tracking-tight mt-3">Profil Bisnis</h1>
        <p className="text-[#4A4A4A] mt-1">Atur info default untuk formulir & menu baru.</p>

        <form onSubmit={save} className="nb-card p-6 mt-6 space-y-4">
          <div className="flex items-center gap-3">
            <div className="w-14 h-14 bg-[#A7E4C0] border-2 border-[#121212] rounded-full flex items-center justify-center">
              <User size={24} weight="bold" />
            </div>
            <div>
              <div className="font-display font-bold text-lg">{user?.email}</div>
              <div className="text-xs text-[#4A4A4A]">Bergabung {user?.created_at ? new Date(user.created_at).toLocaleDateString("id-ID") : "—"}</div>
            </div>
          </div>

          <div>
            <label className="nb-label">Nama / Nama Bisnis</label>
            <input className="nb-input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} data-testid="settings-name-input" />
          </div>
          <div>
            <label className="nb-label">Nomor WhatsApp Default</label>
            <input className="nb-input" value={form.whatsapp_number} onChange={e => setForm({ ...form, whatsapp_number: e.target.value })} placeholder="628123456789" data-testid="settings-wa-input" />
            <p className="text-xs text-[#4A4A4A] mt-1">Akan diisi otomatis ke formulir/menu baru.</p>
          </div>
          <button type="submit" disabled={saving} className="nb-btn nb-btn-primary" data-testid="settings-save-button">
            <FloppyDisk size={18} weight="bold" /> {saving ? "Menyimpan…" : "Simpan"}
          </button>
        </form>
        <CustomHolidaysCard />
      </main>
    </div>
  );
}
